import React from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/bulkPurchase/storageSelectorStyles';
import { IAvailableValueItem } from 'utils/api/models/eshop/products';
import { BodySBold } from 'components/Typography/Typography';
import classNames from 'classnames';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IStorageSelectorProps {
	storages: IAvailableValueItem[];
	setSelectedStorage: React.Dispatch<React.SetStateAction<string>>;
	selectedStorage?: string | null;
}

const StorageSelector = ({ storages, setSelectedStorage, selectedStorage }: IStorageSelectorProps) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.selectorContainer}>
				{(storages || []).map((storage, index) => (
					<div
						onClick={() => {
							setSelectedStorage(storage?.id || '');
						}}
						key={`storage-${index}`}
						className={classNames({
							[classes.singleSelector]: true,
							[classes.selected]: storage?.id === selectedStorage,
							[classes.disabled]: !storage?.available,
						})}
					>
						<BodySBold disableMargin>{storage?.label}</BodySBold>
						<ConditionalRender
							show={!storage?.available}
							onTrue={() => <div className={classes.unavailable}></div>}
						/>
					</div>
				))}
			</div>
		</>
	);
};

export default StorageSelector;
